// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let Statement = function ()
{
    this.Account = null;
    this.InstrumentStr = null;
    this.Date = null;
    this.OperationType = null;
    this.OperationID = null;
    this.Amount = null;
    this.OpenPrice = null;
    this.ClosePrice = null;
    this.Quantity = null;
    this.Currency = null;
    this.TradeOpeningDate = null;
    this.OpenCrossPrise = null;
}

Statement.prototype.Dispose = function ()
{
    this.Account = null;
    this.InstrumentStr = null;
}

